import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.styles.findWord__wrapper)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.styles.findWord)
    }, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.moduleWords) = $event)),
        type: "search",
        placeholder: _ctx.Ti18N('account.findModule'),
        onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.getWord && _ctx.getWord(...args))),
        onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.getWord && _ctx.getWord(...args)), ["enter"]))
      }, null, 40, _hoisted_1), [
        [_vModelText, _ctx.moduleWords]
      ])
    ], 2)
  ], 2))
}